import React from "react";

const SnackBarContext = React.createContext();

export default SnackBarContext;
